
class ReferenceData {

    static data = null;

    static loaded = false;

    static load(url) {

        if (ReferenceData.loaded) { return; }

        ReferenceData.loaded = true;

        fetch(url)
            .then(response => response.json())
            .then(function(res) {
                ReferenceData.data = res;
            }).catch(function(err) {
                console.error(err);
            });
    }

    static getConnectionType(ID) {

        for (let i in ReferenceData.data.ConnectionTypes) {

            let conn = ReferenceData.data.ConnectionTypes[i];

            if (conn.ID === ID) {
                return conn;
            }
        }

        return null;

    }

    static getCurrentType(ID) {

        for (let i in ReferenceData.data.CurrentTypes) {

            let curr = ReferenceData.data.CurrentTypes[i];

            if (curr.ID === ID) {
                return curr;
            }
        }

        return null;

    }

    static getStatusType(ID) {
            
        for (let i in ReferenceData.data.StatusTypes) {

            let stat = ReferenceData.data.StatusTypes[i];

            if (stat.ID === ID) {
                return stat;
            }
        }

        return null;
    
    }

    static getIconForConnector(id) {
        let iconURL = window.THEME_URL + '/img/connectors/';
        if (id === 1) {
            iconURL += 'Type1_J1772.svg';
        } else if (id === 2) {
            iconURL += 'Chademo_type4.svg';
        } else if (id === 25) {
            iconURL += 'Type2_socket.svg';
        } else if (id === 32) {
            iconURL += 'Type1_CCS.svg';
        } else if (id === 33) {
            iconURL += 'Type2_CCS.svg';
        } else if (id === 1036) {
            iconURL += 'Type2_tethered.svg';  
        } else if (id === 26) {
            iconURL += 'Type3c.svg';
        } else if (id === 28) {
            iconURL += 'schuko.svg';
        } else {
            iconURL += 'Unknown.svg';
        }
        return iconURL;
    }

    static isOperativeStatus(id) {
        if ([0, 10, 20, 50, 75].indexOf(id) !== -1) {
            return true;
        }

        return false;
    }

    static getMaxLevelOfPOI(poi) {
        let level = 0;

        if (poi.Connections !== null) {
            for (let c = 0; c < poi.Connections.length; c++) {
                if (poi.Connections[c].LevelID !== null && poi.Connections[c].LevelID > level) {
                    level = poi.Connections[c].LevelID;
                }
            }
        }

        return level;
    }

    static __(string) {
        if (string === 'AC (Three-Phase)') {
            return 'AC (Trifásica)'
        }
        else if (string === 'Type 2 (Socket Only)') {
            return 'Tipo 2 / Mennekes (Solo enchufe)';
        }
        else if (string === 'Type 2 (Tethered Connector) ') {
            return 'Tipo 2 / Mennekes (Tethered)';
        }
        else if (string === 'CCS (Type 2)') {
            return 'CCS Tipo 2';
        }
        else if (string === 'Tesla Supercharger') {
            return 'CCS Tipo 2 / Tesla Supercharger';
        }

        return string;

    }

}

export default ReferenceData;